import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { EmojiPlaceholder } from '@atlaskit/emoji';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	emojiPlaceholderBackground: {
		backgroundColor: token('color.skeleton'),
	},
	wrapperStyles: {
		paddingLeft: token('space.100'),
		paddingRight: token('space.150'),
		marginTop: token('space.negative.025'),
	},
	countSkeletonStyles: {
		width: '10px',
		height: '10px',
		backgroundColor: token('color.skeleton'),
		borderRadius: token('radius.full'),
	},
});

const PLACEHOLDER_COMMON_PROPS = {
	shortName: 'loading-placeholder',
	size: 16,
	xcss: styles.emojiPlaceholderBackground,
};

export const ReactionsSummaryViewPlaceholder = (): React.JSX.Element => {
	return (
		<Inline space="space.050" alignBlock="center" css={styles.wrapperStyles}>
			<EmojiPlaceholder {...PLACEHOLDER_COMMON_PROPS} />
			<EmojiPlaceholder {...PLACEHOLDER_COMMON_PROPS} />
			<EmojiPlaceholder {...PLACEHOLDER_COMMON_PROPS} />
			<div css={styles.countSkeletonStyles} />
		</Inline>
	);
};
